import Icon from '../Icon/Icon';

const CloseIcon = ({className}: {className?: string}) => (
    <Icon width='44' height='44' fill='none' className={className}>
        <rect width='44' height='44' rx='22' fill='#2A2A2B' />
        <path d='M29.31 14.3535L14.3535 29.31' stroke='#FFFDFB' strokeWidth='1.5' strokeLinecap='round' />
        <path d='M14.3531 14.3535L29.3096 29.31' stroke='#FFFDFB' strokeWidth='1.5' strokeLinecap='round' />
    </Icon>
);

export default CloseIcon;
